module.exports = __webpack_public_path__ + "img/brush.e85a7134.svg";